<div class="container-fluid p-3">
     <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
         {{
    schemeType === 'makeI'
      ? 'Cost Negotiation'
      : schemeType === 'tdf' || schemeType == 'idex'
        ? 'Cost Negotiation'
        : 'Commercial Negotiation'
  }}
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span
            class="badge"
            [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }"
          >
            {{
              stepDetails?.step_status == 0
                ? "INITIATION PENDING"
                : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container
          *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            stepDetails?.can_edit ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          "
        >
          <button
            class="btn btn-primary me-2"
            (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="commentForm?.invalid"
          >
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <!-- <div class="row mb-4">
        <div class="col-md-6">
            <div class="card p-3">
                <h5>Commercial Negotiation Document</h5>
                <p class="text-muted">Upload the Commercial Negotiation Document</p>
                <p-fileUpload mode="basic"  #fileUpload chooseLabel="Upload Commercial Negotiation Document" 
                    [auto]="true"   [customUpload]="true" [multiple]="false" (uploadHandler)="onUpload($event)"
                    styleClass="p-button-outlined w-100">
                </p-fileUpload>
                <div class="mt-3" *ngIf="selectedFile?.name">
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{extractFileName(selectedFile.name)}}</span>
                         <button class="btn btn-sm" (click)="clearUpload(fileUpload)">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                </div>
                <div class="mt-3" *ngIf="filePathFromApi">
                    <div class="d-flex justify-content-between align-items-center">
                         <a [href]="apiUrl + filePathFromApi" target="_blank"> {{ extractFileName(filePathFromApi) }}</a>
                        <div class="d-flex gap-2">
                          <a [href]="apiUrl + filePathFromApi" target="_blank">
                            <p-button icon="pi pi-eye" styleClass="p-button-sm p-button-outlined"
                                pTooltip="View Document"></p-button>
                                </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div> -->


  <!-- <form [formGroup]="commentForm">
        <div class="mb-4 editor-container">
            <label class="mb-2 d-block">Justification<b class="text-danger">*</b> <span *ngIf="commentForm.get('comment')?.invalid && commentForm.get('comment')?.touched" class="text-danger mt-1">
                comment is required
            </span></label> -->

  <!-- <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="comment"></ckeditor> -->
  <!-- <editor [init]="init" formControlName="comment"  [disabled]="isEditorDisabled" ></editor>
            
        </div> -->
  <!-- <p-button label="submit" [outlined]="true" icon="pi pi-save" (click)="onSubmit()"></p-button> -->
  <!-- </form> -->

  <div>
    <!-- <div class="mt-3 mb-3 d-flex justify-content-end" *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)">
    <button pButton label="Qualify Vendor" (click)="submitSelectedVendor()" [disabled]="!selectedVendor"
      class="p-button-sm p-button-info"></button>
     </div> -->
    <p-table *ngIf="schemeType !== 'tdf'" [value]="vendors" editMode="row" dataKey="id" #table>
      <ng-template pTemplate="header">
        <tr>
          <th>Vendor Name</th>
          <th *ngIf="schemeType != 'makeI' && schemeType != 'idex' ">Vendor Address</th>
          <th *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">{{schemeType == 'rev' ? 'Cost' : 'Budgetory Quote'}} (in INR)</th>
          <th>Final Price (in INR)</th>
          <th>Level</th>
           <th *ngIf="schemeType == 'rev'">
              Commercial Negotiation held on
            </th>
          <th *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="rowData">
          <td>{{ rowData.vendor.name }}</td>
          <td *ngIf="schemeType != 'makeI' && schemeType != 'idex'">{{ rowData.vendor.address }}</td>

          <!-- Benchmark Price -->
          <td *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
            <!-- <p-cellEditor>
              <ng-template pTemplate="input">
                <input type="number" pInputText [(ngModel)]="rowData.budget" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ rowData.budget}}
              </ng-template>
            </p-cellEditor> -->
            {{ rowData.budget}}
          </td>

            <td>
            <ng-container *ngIf="table.isRowEditing(rowData); else readOnly">
              <input type="number" pInputText [(ngModel)]="rowData.finalPrice" />
            </ng-container>
            <ng-template #readOnly>
              <span>{{ rowData.finalPrice }}</span>
            </ng-template>
          </td>

          <!-- Level -->
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                {{ rowData.level }}
               
              </ng-template>
              <ng-template pTemplate="output">
                {{ rowData.level }}
              </ng-template>
            </p-cellEditor>
          </td>

        
           <td pEditableColumn *ngIf="schemeType == 'rev'">
              <ng-container *ngIf="editing; else viewMode">
                <input type="date" pInputText [(ngModel)]="rowData.date" />
              </ng-container>
              <ng-template #viewMode>
                {{ rowData.date }}
              </ng-template>
            </td>


          <!-- Actions -->
          <td class="min-wid-150"
            *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">

            <button *ngIf="!editing" pButton icon="pi pi-pencil" (click)="table.initRowEdit(rowData)"
              class="p-button-text"></button>

            <button *ngIf="editing" pButton icon="pi pi-check" (click)="onRowEditSave(rowData)"
              class="p-button-text p-button-success"></button>

            <button *ngIf="editing" pButton icon="pi pi-times" (click)="table.cancelRowEdit(rowData)"
              class="p-button-text p-button-danger"></button>

            <button *ngIf="!editing" pButton icon="pi pi-trash" (click)="openDeleteDialog(rowData)"
              class="p-button-text p-button-danger"></button>
          </td>


        </tr>
      </ng-template>
    </p-table>
      <!-- Document Upload Section -->
  <div class="row mb-4 mt-4">
    <div class="col-lg-12">
      <div class="card shadow-sm border-0">
        <div class="card-body p-4">
          <!-- <div class="d-flex align-items-center mb-3">
            <i class="pi pi-file text-primary me-2"></i>
            <h5 class="card-title mb-0"> Negotiation Document</h5>
          </div>
          
          <p class="text-muted mb-4">Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG format (Max size: 200MB)</p> -->
          <!-- <app-upload-document (uploadData)="onDocumentUpload($event)" [dmsFiles]="allDmsFiles"
            (documentEdited)="onDocumentEdited($event)" (documentDeleted)="onDocumentDeleted($event)">
          </app-upload-document> -->
          <app-upload-document [title]="'Commercial Negotiation Document'" [isEditable]="stepDetails?.can_edit"></app-upload-document>

          <!-- Upload Area -->
           <!-- <app-upload-document></app-upload-document> -->
          <!-- <div class="upload-container mb-4" 
               *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
            <div class="upload-area p-4 text-center border rounded" >
             
              
              <p-fileUpload 
                mode="basic" 
                chooseLabel="Browse Files" 
                (uploadHandler)="onUpload($event)"
                [auto]="true" 
                [customUpload]="true" 
                #fileUpload 
                [multiple]="false" 
                [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" 
                [maxFileSize]="209715200"
                styleClass="p-button-rounded p-button-outlined">
              </p-fileUpload>
            </div>
          </div> -->

          <!-- Uploaded File Display -->
          <!-- <div *ngIf="uploadedFileName || uploadedUrl">
            <div class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <i class="pi pi-file me-3 text-primary" style="font-size: 1.5rem;"></i>
                <div>
                  <p class="mb-0 fw-semibold">
                    <a [href]="apiUrl + uploadedUrl" target="_blank" class="text-decoration-none">
                      {{ uploadedFileName || getFileName(uploadedUrl) }}
                    </a>
                  </p>
                  <small class="text-muted">Uploaded successfully</small>
                </div>
              </div>
              <div class="d-flex gap-2">
                <a [href]="apiUrl + uploadedUrl" target="_blank" class="btn btn-sm btn-outline-primary"  *ngIf="uploadedUrl">
                  <i class="pi pi-eye"></i>
                </a>
                
                  <i class="pi pi-times"  (click)="clearUpload(fileUpload)" *ngIf="!uploadedUrl"></i>
               
              </div>
            </div>
          </div> -->

          <!-- No Files State -->
          <div *ngIf="!uploadedFileName && !uploadedUrl && 
                      !(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || stepDetails?.can_edit ||
                      (stepDetails?.step_status != 'approved' && userID == 6))" 
               class="no-file-placeholder p-3 text-center bg-light rounded">
            <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
            <p class="mb-0 text-muted">No files uploaded</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div class="mt-4">
    <form [formGroup]="commentForm">
      <!-- <div class="form-group mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
        <label for="pdsTitle"><strong>• Justification</strong></label>
       
        <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
      </div> -->
      <div class="editor-field">
            <b class="form-label-left">Remarks</b>
            <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
        </div>

    </form>
  </div>
</div>


<p-dialog header="Confirm Delete" [(visible)]="showDeleteDialog" [modal]="true" [closable]="true" appendTo="body"
  [style]="{width: '400px'}" [maximizable]="true">
  <div class="p-3">
    <p>Are you sure you want to delete vendor "<strong>{{ selectedRow?.vendor?.name }}</strong>"?</p>
  </div>
  <div class="p-dialog-footer">
    <button pButton label="Cancel" icon="pi pi-times" class="p-button-text" (click)="showDeleteDialog = false"></button>
    <button pButton label="Delete" icon="pi pi-trash" class="p-button-danger" (click)="confirmDelete()"></button>
  </div>
</p-dialog>


